import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetallePorCondicionLinea4Actions'
import { TablaDetallePorCondicionLinea4View } from '../components/TablaDetallePorCondicionLinea4View'

class TablaDetallePorCondicionLinea4 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetallePorCondicionLinea4View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetallePorCondicionLinea4)
